import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  FormGroup,
} from 'react-bootstrap';

import ConfirmationModal from '../ConfirmationModal.jsx';
import { createDriverSelfRating } from '../../actions/form';

export class FieldRatingSelfSubmit extends Component {
  constructor(props) {
    super(props);
    this.submitRating = this.submitRating.bind(this);
    this.isValidForm = this.isValidForm.bind(this);
    this.openSubmitConfirm = this.openSubmitConfirm.bind(this);
    this.closeSubmitConfirm = this.closeSubmitConfirm.bind(this);

    this.state = {
      askConfirm: false,
    };
  }

  isValidForm() {
    const fields = this.props.ratingSelf;
    if (this.props.isValidForm) return this.props.isValidForm(fields);

    return (!_.isUndefined(fields.date)
      && !_.isEmpty(fields.driverName)
      && !_.isEmpty(fields.series)
      && !_.isEmpty(fields.track));
  }

  openSubmitConfirm() {
    this.setState({ askConfirm: true });
  }

  closeSubmitConfirm() {
    this.setState({ askConfirm: false });
  }

  submitRating() {
    this.props.createDriverSelfRating(this.props.ratingSelf, this.props.formType, this.props.redirectTo);
  }

  renderConfirmation() {
    if (this.state.askConfirm) {
      return (
        <ConfirmationModal
          showModal
          onConfirm={this.submitRating}
          onClose={this.closeSubmitConfirm}
          message="Are you sure you want to submit your rating? This action cannot be undone."
        />
      );
    }

    return null;
  }

  render() {
    return (
      <div>
        {this.renderConfirmation()}

        <FormGroup>
          <Button onClick={this.openSubmitConfirm} disabled={!this.isValidForm()}>
            {this.props.buttonText || 'Submit'}
          </Button>
        </FormGroup>
      </div>
    );
  }
}

export const mapStateToProps = state => ({
  ratingSelf: state.form.ratingSelf.fields,
});

export default connect(
  mapStateToProps,
  { createDriverSelfRating },
)(FieldRatingSelfSubmit);

FieldRatingSelfSubmit.propTypes = {
  buttonText: PropTypes.string,
  redirectTo: PropTypes.string,
  formType: PropTypes.oneOf(['practice', 'qualifying', 'race', 'reflection', 'dirt']).isRequired,
};
